
    import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
    import {translate} from "../../services/translation/translation";
    import "./project-gallery-destop.less";


    @Component({
        components: {
        }
    })
    export default class ProjectGalleryDestop extends Vue {
        @Prop() images;
        private data ={
            'index' :0,
            'visible' :false,
            'images': []
        };
        mounted() {
            if(this.isExist(this.images)){
                this.data.images = this.images;
            }
            let self = this;
            setTimeout(function () {
                self.initGaleryView();
            }, 200);
            $(window).resize(this.initGaleryView)
        }

        trans(key) {
            return translate(key);
        };
        initGaleryView(){
            let self = this;
             $('.project-image-container .widescreen').each(function (i, e) {
                let elem: any= $(e);
                let width: any= elem.width();
                if (elem.hasClass('big'))
                    elem.height(width * 9 / 16);
                else {
                    const big = $('.big');
                    const height = big!.height();
                    elem!.height(height! / 2 - 2.5);
                    }
             })

            // $('.project-image-container .widescreen').each(function (i, e) {
            //     let elem: any= $(e);
            //     let width: any= elem.width();
            //     let projectContainer: any= $('.project-image-container').height();
            //     if(elem !== undefined){
            //         if (elem.hasClass('big')) {
            //             elem.css('height', (width * 0.5625));
            //             elem.css('max-height', (width * 0.5625));
            //         } else {
            //             elem.css('height', projectContainer * 0.499);
            //             elem.css('max-height', projectContainer * 0.499);
            //             $('.a-count-container').css('height', projectContainer * 0.499);
            //             $('.a-count-container').css('max-height', projectContainer * 0.499);
            //         }
            //     }
            // });
            $('.project-image-container').addClass('visible');

            // $('.project-image-container img').each(function(i, img) {
            //     self.addClassToImages(img);
            // })
        }

        imgRatio = 16 / 9;

        loaded(ev) {
            const img = $(ev.target);
            if (img.length) {
            img
                .eq(0)
                .addClass(
                img.get(0).naturalWidth! / img.get(0).naturalHeight! < this.imgRatio
                    ? "narrow"
                    : "wide"
                );
            }
  }

        isExist(attributes :any){
            if(attributes == null || typeof attributes == undefined){
                return false;
            } else {
                return true;
            }
        }

        @Emit("showModalGallery")
        onShowModalGallery(index, visible){
        }

    }
